export const ewayBillNotes = `
# \n\n
### Steps to Enable e-Way Bill 
1. Go to [ewaybillgst.gov.in](https://ewaybillgst.gov.in) and click e-Way Bill Registration.
 
2. Create a User ID & Password for the e-Way Bill portal.
 
3. Log in again with this new User ID and Password.
 
4. Go to Registration → For GSP (from the left menu).
 
5. Select the GSP option and choose Alankit Limited from the dropdown list.
 
6. A new API User ID will be created by default (often ending with "_API").
 
7. Enter a Password for this API User ID and click Submit.
 
8. Note: This API User ID & Password is what LedgerX will use (different from your normal portal login).
 
---
 
### Configure in LedgerX 
9. In LedgerX, go to Company Setup → Enable e-Way Bill.
 
10. Enter the API User ID & Password you created in Step 7.
 
11. Click Save & Connect Permanently (or you can enter credentials each time).
 
---
 
### Generate e-Way Bill 
12. From the Sales Invoice List, click Generate e-Way Bill.
 
13. If credentials weren't saved, enter the API User ID & Password.
 
14. Click Submit → the official e-Way Bill Number (EBN) will be generated and shown in LedgerX.
`;
